module.exports = __webpack_public_path__ + "img/notNearIcon.03d32345.svg";